// The administration start: one ruled list of what the organisation's administrators reach.
import { Link } from 'react-router';
import { sv } from '@aldorock-fordon/shared/sv';
import type { Me } from '../api.ts';
import { usePage } from '../page.ts';
import { PageHead } from '../ui/PageHead.tsx';

export function AdminHome({ me }: { me: Me }) {
  const h1 = usePage(sv.adminHome.title);
  const p = me.permissions;
  const items: Array<{ key: string; to: string; show: boolean }> = [
    { key: 'imports', to: '/admin/inlasning', show: p['import.run'] },
    { key: 'billing', to: '/admin/debitering', show: p['billing.run'] },
    { key: 'keys', to: '/nyckelskap', show: p['key.manage'] },
    { key: 'pools', to: '/bilpooler', show: p['pool.manage'] },
    { key: 'fields', to: '/admin/fritextfalt', show: p['settings.manage'] },
    { key: 'roles', to: '/admin/roller', show: p['role.manage'] },
    { key: 'idp', to: '/admin/inloggning', show: p['settings.manage'] },
    { key: 'audit', to: '/admin/logg', show: p['audit.view'] },
    { key: 'api', to: '/admin/api', show: p['settings.manage'] },
  ];
  return (
    <>
      <PageHead help="admin" title={sv.adminHome.title} titleRef={h1} />
      <p>{sv.adminHome.intro}</p>
      {p['export.run'] ? (
        <section className="block" aria-labelledby="export">
          <h2 className="block-title" id="export">
            {sv.exportAdmin.title}
          </h2>
          <p>{sv.exportAdmin.intro}</p>
          <p className="actions-inline">
            <a className="btn" href="/api/v1/admin/export" download>
              {sv.exportAdmin.button}
            </a>
          </p>
        </section>
      ) : null}
      <ul className="plain admin-list">
        {items
          .filter((i) => i.show)
          .map((i) => (
            <li key={i.key}>
              <Link to={i.to}>{sv.adminHome.sections[i.key]}</Link>
              <span className="caption">{sv.adminHome.descriptions[i.key]}</span>
            </li>
          ))}
      </ul>
    </>
  );
}
